import { render, staticRenderFns } from "./GradedFollowUps.vue?vue&type=template&id=0421c918&scoped=true"
import script from "./GradedFollowUps.vue?vue&type=script&lang=js"
export * from "./GradedFollowUps.vue?vue&type=script&lang=js"
import style0 from "./GradedFollowUps.vue?vue&type=style&index=0&id=0421c918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421c918",
  null
  
)

export default component.exports